import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRoutingOutcome.ts
var t = () => e("routingOutcome");
//#endregion
export { t as useTrRoutingOutcome };
